import { useMutation } from '@tanstack/react-query';

import { $apiV2, errorHandler } from 'modules/global';

export const useFollowTeacher = () =>
  useMutation({
    mutationFn: async (teacherId?: number) => {
      const { data } = await $apiV2.post(`/follow/create`, { teacher_id: teacherId });

      return data;
    },
    onError: errorHandler()
  });
